export const TIMEOUT = "/timeout";
export const ELECTRONIC_AGREEMENT = "/electronic-agreement";
export const ELECTRONIC_AGREEMENT_FULL = "/electronic-agreement-full-content";
export const INTEREST_DISCLOSURE = "/interest-rates-and-charges";
export const ORGANIC_LANDING = "/";
export const ORGANIC_APP = "/apply";
export const INVITE_LANDING = "/invite";
export const INVITE_APP = "/apply-invite";
export const CONGRATULATIONS = "/congrats";
export const APPROVED_DEFAULT = "/approved";
export const APPROVED_SECURED = "/approved-secured";
export const PROCESSING = "/processing";
export const THANK_YOU = "/thank-you";
export const DUPLICATE = "/duplicate";
export const DUPLICATE_DSN = "/duplicate-dsn";
export const FORGOT_INVITE = "/forgot-invite";
export const ERROR = "/error";
export const REVIEW_COMPLETE = "/review-complete";
export const SECURED_CARD = "/secured-terms";
export const SECURED_DEPOSIT = "/secured-deposit";
export const SECURED_FUND_LATER_SUBMITTED = "/secured-fund-later";
export const SECURED_FORGOT = "/secured-forgot";
export const WELCOME_BACK = "/secured";
export const REFERRAL_PAGE = "/referral-page";
export const REFERRAL_SHARE = "/referral-share";
export const REFERRAL_CLAIM = "/referral-claim";
export const REFERRAL_ERROR = "/referral-error";
export const REACCESS_REFERRAL_SHARE = "/referral-code";
